import React, { memo } from 'react'

import { Icon, MoreFilters } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Dropdown from 'Pods/ThreeDStudio/Shared/Dropdown/Dropdown'

import FilteringContent from './Components/FilteringContent/FilteringContent'

const size = { height: '14px', width: '14px' }
const icon = <Icon notSpaced svgComponent={MoreFilters} color="dark" size={size} />
const content = <FilteringContent />

function Filtering() {
  return (
    <Dropdown
      icon={icon}
      content={content}
      placement="bottom-start"
      usePortal
    />
  )
}

export default memo(Filtering)
